import { CheckCircle } from "@mui/icons-material";

import { InfoPage } from "../../../shared/components/info-page/info-page";
import { InfoPageIllustration } from "../../../shared/components/info-page/info-page-illustration";
import { InfoPageLayout } from "../../../shared/components/info-page/info-page-layout";
import { SignInButton } from "../components/sign-in-button";

/** Финал явного выхода. Вход сам не запускается. */
export const SignedOutPage = (): JSX.Element => (
  <InfoPageLayout>
    <InfoPage
      title="Вы вышли из EkoCrop"
      message="Чтобы продолжить работу, войдите снова"
      illustration={<InfoPageIllustration icon={CheckCircle} />}
      actions={<SignInButton label="Войти" />}
    />
  </InfoPageLayout>
);
